import { GridPostParams } from "common/models/utility-models/list-utility.model";

export class ApplicantReportsGridPostParams extends GridPostParams {
    region_search: string = '';
    branch_search: string = ''; // pass branch cat id
    state_search: string = '';
    gender_search: string = '';
    status_search: string = '';
}
